import { render, staticRenderFns } from "./ImportedFile.vue?vue&type=template&id=1138d132&scoped=true&"
import script from "./ImportedFile.vue?vue&type=script&lang=js&"
export * from "./ImportedFile.vue?vue&type=script&lang=js&"
import style0 from "./ImportedFile.vue?vue&type=style&index=0&id=1138d132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138d132",
  null
  
)

export default component.exports